"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sportBelongsToCategory = sportBelongsToCategory;
exports.probabilitySettled = probabilitySettled;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
function sportBelongsToCategory(sportId, vCategoryInfo) {
    return vCategoryInfo.sportIds.has(sportId);
}
function probabilitySettled(event) {
    return event.tradingStatus === betweb_openapi_axios_1.EventProbabilityTradingStatus.Settled;
}
//# sourceMappingURL=index.js.map